import RegenerateKeyForm from './RegenerateKeyForm'

export default RegenerateKeyForm
